import React from "react";
import Card from "../../componentes/contenedores/Card";
import PerfilUsuario from "../../componentes/contenedores/PerfilUsuario";
import Page from "../../componentes/plantilla/Page";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";

const HomeEmpleados = () => {
  const { usuario } = useContextUsuario();
  
  const datos = {
    titulo: {
      titulo: "Edicion de perfil",
      url: "/app/admin/",
      tituloUrl: "home",
      nombreUrl: "Peril",
    },
  };

  return (
    <Page datos={datos}>
      <Card titulo="Perfil de usuario">
        <PerfilUsuario datos={ usuario.datoPersonales} />
      </Card>
    </Page>
  );
};

export default HomeEmpleados;
